import { Button } from './button';
import { Counter } from './button-counter';
export const NewButton = Object.assign(Button, {
  Counter
});